import React, { Component } from "react";
import { ajaxWrapper } from "functions";

export default class ActionTags extends React.Component {
	render() {
		var action = this.props.action;

		var tags = [];
		if ("dc_type" in action.action_dc) {
			tags.push(
				<div className="col-3">
					<div className="fancy_border">
						<div className="header">DC</div>
						<div
							style={{ fontSize: ".8rem" }}
						>{`DC ${action.action_dc["dc_roll"]} ${action.action_dc["dc_type"]} save`}</div>
					</div>
				</div>,
			);
		}
		if ("attack_roll" in action.attack_roll) {
			tags.push(
				<div className="col-3">
					<div className="fancy_border">
						<div className="header">To Hit</div>
						<div style={{ fontSize: ".8rem" }}>{`1d20 + ${action.attack_roll["attack_roll"]}`}</div>
					</div>
				</div>,
			);
		}

		if (!Array.isArray(action.action_damage) && action.action_damage.constructor === Object) {
			action.action_damage = Object.values(action.action_damage);
		}
		for (let damage of action.action_damage) {
			if (damage["damage_scaling"] == "level" || damage["damage_scaling"] == "cast_level") {
				for (let index = 0; index < 21; index++) {
					if (!damage["damage_by_level"] || !(index in damage["damage_by_level"])) {
						continue;
					}

					let type = damage["damage_type"] ? " " + damage["damage_type"] : "";

					tags.push(
						<div className="col-3">
							<div className="fancy_border">
								<div className="header">Damage</div>
								<div
									style={{ fontSize: ".8rem" }}
								>{`${damage["damage_by_level"][index]}${type} damage by level`}</div>
							</div>
						</div>,
					);
					break;
				}
			} else {
				if (!("damage_roll" in damage)) {
					continue;
				}

				tags.push(
					<div className="col-3">
						<div className="fancy_border">
							<div className="header">Damage</div>
							<div
								style={{ fontSize: ".8rem" }}
							>{`${damage["damage_roll"]} ${damage["damage_type"]} damage`}</div>
						</div>
					</div>,
				);
			}
		}

		return <div className="row">{tags}</div>;
	}
}
